<template>
<v-card>
    <v-card-text>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    label="Поиск"
                    filled
                    rounded
                    dense
                    v-model="filters.search"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-btn
                    v-if="!isResponseState"
                    class="mr-3 my-2"
                    @click="filters.status ='active'"
                    :disabled="filters.status === 'active'"
                    :large="filters.status === 'active'"
                    
                >Новые</v-btn>
                <v-btn
                    v-if="!isResponseState"
                    class="mr-3 my-2"
                    @click="filters.status ='archive'"
                    :disabled="filters.status === 'archive'"
                    :large="filters.status === 'archive'"
                >Завершенные</v-btn>
                <v-btn
                    v-if="!isResponseState"
                    class="mr-3 my-2"
                    @click="filters.status = null"
                    :disabled="filters.status === null"
                    :large="filters.status === null"
                >Все</v-btn>
                <v-btn
                    v-if="filters.status === 'active'"
                    :color="!isResponseState ? 'primary' : 'default'"
                    class="mr-3 my-2"
                    @click="isResponseState = ! isResponseState"
                    :large="true"
                >{{isResponseState ? 'Закрыть режим ответа' : 'Ответить'}}</v-btn>
                <v-btn
                    v-if="filters.status === 'active' && !isResponseState && tableData.length > 0"
                    color="primary"
                    class="mr-3 my-2"
                    @click="onDownloadReport"
                    :large="true"
                    :loading="fetchDowloadReport"
                >Скачать</v-btn>
                <v-btn
                    v-if="isResponseState"
                    :disabled="isFetchImport"
                    :loading="isFetchImport"
                    color="primary"
                    class="mr-3 my-2"
                    :large="true"
                    @click="onImportResponses"
                >
                {{isFetchImport ? "Генерация ответов..." : "Отправить в ГИС ЖКХ"}}
            </v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-text-field
                    v-if="isResponseState"
                    readonly
                    :loading="IS_FETCHING"
                    :value="FULL_NAME"
                    class="mr-3"
                    label="Отправитель"
                    outlined
                    dense
                    :append-outer-icon="HAS_EXECUTOR ? 'mdi-pencil' : 'mdi-plus'"
                    @click:append-outer="onDialogEditExecutor"
                    @click="onDialogEditExecutor"
                ></v-text-field>
                <v-btn v-else @click="notifyConfigDialog = true" color="success" class="ma-2 mr-3 my-2" :large="true">   
                    Уведомления   
                    <v-icon
                        right
                        dark
                    >
                       mdi-cog
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="8">
                <v-row>
                    <v-col cols="8">
                        <v-switch
                            v-model="debtImportAutomatCheckBox"
                            @change="onChangeDebtImportAutomat"
                            :input-value="IS_ENABLE_DEBT_IMPORT_AUTOMAT"
                            :disabled="fetchDebtImportAutomat"
                            :loading="fetchDebtImportAutomat"
                        >
                            <template v-slot:label>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        {{debtImportAutomatSwitchLabel}} <v-icon
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi-help-circle-outline
                                    </v-icon>
                                    </template>
                                    <span>Включить автоматические ответы можно на 2 недели. После, опция будет отключена до повторного включения.</span>
                                </v-tooltip>
                            </template>
                        </v-switch>

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8">
                        <v-col cols="4" v-if="filters.mode !== 'response' && filters.status === 'active' && tableData.length > 0">
                            Найдено должников: {{exportResults.count_debtors}}
                            <v-btn
                                class="mx-2"
                                fab
                                dark
                                color="success"
                                x-small
                                @click="() => $router.push({name: 'SocialPersonDebtors'})"
                            >
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-row>
                    <v-col cols="12">
                        <v-expand-transition>
                            <v-alert
                                v-if="importCounters.prev.isShow"
                                border="top"
                                colored-border
                                type="info"
                                elevation="2"
                            >
                                {{importCounters.prev.message}} <br/>
                                <b v-if="importCounters.current.isShow" style="color: red">{{importCounters.current.message}}</b>
                            </v-alert>
                        </v-expand-transition>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="alerts.length > 0">
            <v-col cols="12">
                <v-alert
                    v-for="alert in alerts" :key="alert.id" 
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                >
                    <span v-html="alert.message"></span>
                </v-alert>
            </v-col>
        </v-row>
        <v-row v-if="isShowWarningGis">
            <v-col cols="12">
                <v-alert
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                >
                    В выходные дни ГИС ЖКХ может выдавать ошибку на прием запросов. Если вы столкнулись с ошибкой в этот временной промежуток, то попробуйте повторить отправку запросов в рабочий день (с 9:00 UTC+3).
                </v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :single-expand="true"
                    :show-expand="show_expand"
                    :expanded.sync="expanded"
                    :headers="tableHeaders"
                    :loading="isFetchResults || isFetchImport"
                    :loading-text="datatable_loading_text"
                    :items="tableData"
                    disable-pagination
                    class="elevation-1"
                    hide-default-footer
                    :show-select="isResponseState"
                    @item-selected="onItemSelect"
                    @toggle-select-all="onToggleSelectAll"
                    :value="selectedIds"
                >
                    <template v-slot:top>
                        <v-toolbar flat v-if="isResponseState">
                            <v-toolbar-title>
                                Выбрано: {{selectedLength}} / 
                                Кол-во должников: {{importDebtorsLength}}
                                <v-btn
                                    class="mx-2"
                                    color="primary"
                                    icon
                                    @click="filters.onlyDebtor = ! filters.onlyDebtor"
                                >
                                    <v-icon v-if="!filters.onlyDebtor">
                                        mdi-eye-outline
                                    </v-icon>
                                    <v-icon v-else>
                                        mdi-eye-off-outline
                                    </v-icon>
                                </v-btn>
                            </v-toolbar-title>
                            <v-divider
                            class="mx-4"
                            inset
                            vertical
                            ></v-divider>
                            <v-radio-group
                                class="mt-5"
                                v-model="selectedMode"
                                v-if="isResponseState"
                                row
                            >
                                <v-radio
                                    label="Исключить"
                                    value="sended"
                                ></v-radio>
                                <v-radio
                                    label="Отправить"
                                    value="exclude"
                                ></v-radio>
                            </v-radio-group>
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                color="green"
                                @click="loadExportResults"
                                :disabled="isFetchResults"
                            >
                                <v-icon>mdi-cached</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-toolbar flat dense v-else>
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                color="green"
                                @click="loadExportResults"
                                :disabled="isFetchResults"
                            >
                                <v-icon>mdi-cached</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </template>
                    <template v-if="isResponseState || filters.status === 'archive'" v-slot:[`item.has_debt`]="{ item }">
                        <div v-if="isResponseState">
                            <span style="color:orangered" v-if="item.housePersonDebtors.length > 0">Найдена</span>
                            <span v-else>Не найдена</span>
                        </div>
                        <div v-if="filters.status === 'archive'">
                            <div v-if="item.importResponseLast && item.importResponseLast.ais_status != 'ERROR'">
                                <span v-if="item.importResponseLast.responseData && item.importResponseLast.responseData.hasDebt" style="color:orangered">
                                    С должником
                                </span>
                                <span v-else>Без должника</span>
                            </div>
                        </div>
                    </template>
                     <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                            v-if="showActionDetails"
                            class="mr-2"
                            @click="showDetails(item)"
                        >
                            mdi-eye
                        </v-icon>
                    </template>
                    <template v-slot:[`item.responseStatus`]="{ item }">
                        <v-chip
                            :color="getColorStatus(item.responseStatus)"
                            dark
                        >
                            {{ item.responseStatus_slug }}
                        </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <div v-if="item.housePersonDebtors && item.housePersonDebtors.length > 0">
                                Должники:<br/>
                                <div v-for="(debtor, index) in item.housePersonDebtors" :key="debtor.id">
                                        {{index + 1}}. {{debtor.full_name}}, №{{debtor.judgment_number}} от {{debtor.date_of_judgment}}
                                </div>
                            </div>
                        </td>
                    </template>
                </v-data-table>
                <v-dialog
                    v-model="showDetailsDialog"
                    v-if="showDetailsItem"
                >
                    <v-card>
                        <v-card-title>
                            <span class="text-h5"></span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <p>
                                    <strong>Данные запроса:</strong>
                                    {{ ({...showDetailsItem, importResponseLast: ''}) }}
                                </p>
                                <p>
                                    <strong>Данные ответа:</strong>
                                    {{showDetailsItem.importResponseLast}}
                                </p>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="closeDetails"
                            >
                                Закрыть
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="text-center">
                    <v-pagination
                        :disabled="isFetchResults"
                        v-model="exportResults.meta.current_page"
                        :length="exportResults.meta.last_page"
                        total-visible="25"
                        @input="onPaginate"
                    ></v-pagination>
                </div>
            </v-col>
        </v-row>
    </v-card-text>
    <v-dialog
        v-model="executorDialog"
        max-width="800"
    >
        <v-card>
            <v-card-title>
                <span class="text-h5">Данные отправителя</span>
            </v-card-title>
            <v-card-text>
                <v-form ref="formExecutorEdit" v-model="formExecutorEditValid">
                    <v-container>
                        <v-row>
                            <v-col
                                cols="6"
                                sm="12"
                                md="6"
                            >
                                <v-text-field
                                    label="Фамилия"
                                    :rules="[
                                            v => !!v || 'Обязательно к заполнению', 
                                            v => v !== 'Илюнин' || 'Невозможно использовать аккаунт Илюнина С.С.'
                                        ]"
                                    v-model="executorEdit.first_name"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                sm="12"
                                md="6"
                            >
                                <v-text-field
                                    label="Имя"
                                    :rules="[v => !!v || 'Обязательно к заполнению']"
                                    v-model="executorEdit.last_name"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="6"
                                sm="12"
                                md="6"
                            >
                                <v-text-field
                                    label="Отчество"
                                    v-model="executorEdit.middle_name"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="6"
                                sm="12"
                                md="6"
                            >
                                <v-text-field
                                    label="ID Отправителя"
                                    :rules="[v => !!v || 'Обязательно к заполнению',
                                            v => /^([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}$/.test(v) || 'Невалидный ID Отправителя']"
                                    v-model="executorEdit.executor_guid"
                                    required
                                >
                                <template v-slot:append>
                                    <v-icon color="success"
                                            v-if="executorEdit.executor_guid && 
                                            /^([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}$/.test(executorEdit.executor_guid)"
                                    >
                                        mdi-check
                                    </v-icon>
                                </template>
                                </v-text-field>
                                <label v-if="!executorEdit.executor_guid || 
                                            ! /^([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}$/.test(executorEdit.executor_guid)" 
                                            style="margin-top:-10%;margin-left: -14px;">Пример: a567cad7-1fc9-123b-3456-7a4b28ba78af
                                </label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="executorDialog = false"
                                >
                                    Отмена
                                </v-btn>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="onSaveExecutor"
                                >
                                    Сохранить
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-row>
                    <debtors-connect-g-i-s></debtors-connect-g-i-s>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog
      v-model="notifyConfigDialog"
      width="1200"
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
            <v-toolbar-title>                    
                <v-icon right dark>mdi-cog-outline</v-icon>
                Уведомления
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    icon
                    dark
                    @click="notifyConfigDialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
            </v-toolbar>
            <v-card-title></v-card-title>
            <v-card-text>
                <social-notify v-if="notifyConfigDialog"></social-notify>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogEnableAutoResponses"
        width="640"
    >
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-toolbar-title>
            <v-icon right dark>mdi-cog-outline</v-icon>
              Включить автоматическое отправление
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                dark
                @click="dialogEnableAutoResponses = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-radio-group
              v-model="enableAutoResponsesRadioGroup"
              mandatory
          >
            <v-radio
                label="14 дней бесплатно"
                value="free"
            ></v-radio>
            <v-radio v-if="IS_ADMIN"
                label="На месяц и более по подписке"
                value="subs"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="pull-right" color="primary" @click="onClickNextOnRadioAutoResponses">
            Продолжить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-card>
</template>

<script>
import DebtorsConnectGIS from '@/app/pages/Instructions/DebtorsConnectGIS.vue';
import * as organizationApi from '@/api/organizations';
import * as notificationApi from '@/api/notifications';
import SocialNotify from '../../components/social/SocialNotify.vue';
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';
import _ from 'lodash';

export default {
    name: 'SocialPage',
    components:{
        DebtorsConnectGIS, SocialNotify
    },
    data(){
        return {
            importCounters:{
                prev: {
                    message: '',
                    organization: 0,
                    workSpace: 0,
                    isShow: false
                },
                current: {
                    message: '',
                    organization: 0,
                    workSpace: 0,
                    isShow: false
                }
            },
            debtImportAutomatCheckBox: false,
            fetchDebtImportAutomat: false,
            alerts: [],
            fetchDowloadReport: false,
            notifyConfigDialog: false,
            expanded: [],
            formExecutorEditValid: false,
            executorDialog: false,
            executorEdit: {},
            showDetailsItem: null,
            showDetailsDialog: false,
            selectedMode:'exclude',
            excludeIds: [],
            isResponseState: false,
            isFetchResults: false,
            isFetchImport: false,
            exportResults: {
                count_debtors: 0,
                meta: {
                    per_page: 5,
                    current_page: 1,
                    total: 0,
                    last_page: 1
                },
                data: []
            },
            filters: {
                status: "active",
                search: null,
                mode: null,
                onlyDebtor: false
            },
            waitExport: {
                uuid: null,
                timestamp: null
            },
            waitExportInv: null,
            dialogEnableAutoResponses: false,
            enableAutoResponsesRadioGroup: null
        }
    },
    created(){
        if(this.ORGANIZATION_DEBT_RESULTS_STATUS !== 'CONNECT'){
            this.$router.push({name: 'OrganizationConnection'});
        }
        this.loadAlerts();
        this.loadExportResults();
        this.importCounts();
        let socialPageWaitExport = localStorage.getItem('socialPageWaitExport');
        if(socialPageWaitExport !== null){
            let socialPageWaitExportObj = JSON.parse(socialPageWaitExport);
            let mins = Math.floor((Date.now() - socialPageWaitExportObj.timestamp) / 1000 / 60);
            if(mins > 60){
                this.clearWaitExport();
            }else{
                this.waitExport = Object.assign({}, this.waitExport, socialPageWaitExportObj);
            }
        }
        this.debtImportAutomatCheckBox = this.IS_ENABLE_DEBT_IMPORT_AUTOMAT;
    },
    beforeDestroy(){
        if(this.waitExportInv){
            clearInterval(this.waitExportInv);
        }
    },

    watch:{
        IS_ENABLE_DEBT_IMPORT_AUTOMAT(newValue){
            this.debtImportAutomatCheckBox = newValue;
        },
        ORGANIZATION_DEBT_RESULTS_STATUS(newValue){
            if( newValue !== 'CONNECT' ){
                this.$router.push({name: 'OrganizationConnection'});
            }
        },
        isResponseState (newValue) {
            this.excludeIds.splice(0, this.excludeIds.length);
            if(true === newValue){
                this.filters.mode = 'response';
            }else{
                this.filters.mode = null;
            }
        },
        ORGANIZATION_ID () { 
            this.excludeIds.splice(0, this.excludeIds.length);
            this.loadExportResults();
            this.loadAlerts();
            this.importCounts();
        },
        filters: {
            handler() {
                this.exportResults.meta.current_page = 1;
                this.onFilter();
            },
            deep: true
        },

        'filters.status': function (){
            this.isResponseState = false;
        },
        'filters.mode': function (){
            this.expanded.splice(0, this.expanded.length);
        },
        'waitExport.uuid': function (newValue){
            if(newValue === null){
                this.fetchDowloadReport = false;
            }else{
                this.fetchDowloadReport = true;
                this.upWaitExportInterval();
            }
        },
    },
    methods: {
        async importCounts(){
            let { data } = await organizationApi.importDebtResponsesCounter(this.ID_WORK_SPACE, this.ORGANIZATION_ID);
            if( ! _.isEmpty(data.current) ){
                this.importCounters.current.isShow = true;
                this.importCounters.current.organization = data.current.countResponsesOrganization;
                this.importCounters.current.workSpace = data.current.countResponsesWorkSpace;
                this.importCounters.current.message = data.current.message;
            }
            if( ! _.isEmpty(data.prev) ){
                this.importCounters.prev.isShow = true;
                this.importCounters.prev.organization = data.prev.countResponsesOrganization;
                this.importCounters.prev.workSpace = data.prev.countResponsesWorkSpace;
                this.importCounters.prev.message = data.prev.message;
            }
        },
        loadAlerts(){
            organizationApi.organizationImportErrorCode(                    
                this.ID_WORK_SPACE, 
                this.ORGANIZATION_ID
            ).then(({data} ) => {
                this.alerts.splice(0, this.alerts.length, ...data)
            }).catch(err => {
                console.log(err);
            });
        },
        upWaitExportInterval(){
            this.waitExportInv = setInterval(async () => {
                await this.checkExport();
            }, 5000);
        },
        newWaitExport(uuid){
            this.waitExport.uuid = uuid;
            this.waitExport.timestamp = Date.now();
            localStorage.setItem('socialPageWaitExport', JSON.stringify(this.waitExport));
        },

        clearWaitExport(){
            this.waitExport.uuid = null;
            this.waitExport.timestamp = null;
            localStorage.removeItem('socialPageWaitExport');
            clearInterval(this.waitExportInv)
        },
        downloadExportReady(uuid){
            notificationApi.exportReadyDownload(uuid).then(({data}) => {
                this.download(data);
                this.clearWaitExport();
            }).catch(res => {
                this.SHOW_ERROR('Произошла ошибка скачивания отчета');
                this.clearWaitExport();
                console.log(res);
            })
        },
        download(data){
            const href = URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'Отчет по запросам.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        },

        async checkExport(){
            notificationApi.exportReadyCheck(this.waitExport.uuid).then(({data}) => {
                if(data.ok == true){
                    if('error' in data){
                        this.SHOW_ERROR('Произошла ошибка генерации отчета. Повторите попытку');
                        this.clearWaitExport();
                    }else{
                        this.downloadExportReady(data.uuid);
                    }
                }
            }).catch(res => {
                this.SHOW_ERROR('Произошла ошибка скачивания отчета');
                this.clearWaitExport();
                console.log(res);
            });
        },

        async onDownloadReport(){
            this.fetchDowloadReport = true;
            try{
                let {data} = await organizationApi.exportDebtResultMessageReport(
                    this.ID_WORK_SPACE, 
                    this.ORGANIZATION_ID, 
                    {params: this.filters}
                );
                this.SHOW_SUCCESS(data.message);
                this.newWaitExport(data.uuid);
            }catch(e){
                console.log(e);
                this.SHOW_ERROR(e);
            }
        },
        async onSaveExecutor(){
            if( ! this.$refs.formExecutorEdit.validate() ){
                return;
            }
            let response = await this.STORE_OR_UPDATE_EXECUTOR(this.executorEdit);
            if(response.result === 'ok'){
                this.executorDialog = false;
                this.SHOW_SUCCESS('Исполнитель успешно обновлен');
            }
           if(response.result === 'error'){
                this.executorDialog = false;
                this.SHOW_ERROR('Произошла ошибка обновления исполнителя');
            }
        },
        onDialogEditExecutor(){
            if(this.HAS_EXECUTOR){
                this.executorEdit = {...this.EXECUTOR};
            }else{
                this.executorEdit = {};
            }
            this.executorDialog = true;
        },
        closeDetails(){
            this.showDetailsItem = null;
            this.showDetailsDialog = false;
        },
        showDetails(item){
            this.showDetailsItem = item;
            this.showDetailsDialog = true;
        },
        onToggleSelectAll(data){
            for(let item of data.items){
                this.onItemSelect({item, value: data.value});
            }
        },
        onItemSelect(data){
            if(data.value === false){
                this.excludeIds.push(data.item);
            }else{
                let index = this.excludeIds.findIndex(v => v.subrequestGUID == data.item.subrequestGUID);
                if(-1 !== index){
                    this.excludeIds.splice(index, 1);
                }
            }
        },
        ...mapActions('notifications', ['SHOW_MESSAGE', 'SHOW_ERROR', 'SHOW_SUCCESS']),
        ...mapActions('user', ['UPDATE_EXECUTOR_GUID']),
        ...mapActions('organizationExecutor', ['STORE_OR_UPDATE_EXECUTOR']),
        ...mapActions('organization', ['TOGGLE_DEBT_IMPORT_AUTOMAT']),
        getColorStatus(status){
            if('NotSent' === status){
                return 'warning';
            }
            if('Sent' === status){
                return 'light-green';
            } 
            if('SENT_PENDING_UPDATE' === status){
                return 'lime';
            } 
            if('AutoGenerated' === status){
                return 'deep-orange';
            }
            if('ERROR' === status){
                return 'red lighten-1';
            }
            return 'grey';
        },

        async onImportResponses(){
            if( ! this.HAS_EXECUTOR ){
                this.SHOW_ERROR('Отправитель не заполнен');
                return ;
            }
            this.isFetchImport = true;
            try{
                await this.importResponses();
            }finally{
                this.isFetchImport = false;
                this.isResponseState = false;
                this.loadExportResults();
            }
        },

        async importResponses(){
            try{
                let { data } = await organizationApi.importDebtResponses(
                    this.ID_WORK_SPACE, 
                    this.ORGANIZATION_ID, 
                    {excludeIds: this.excludeIds.map(v=>v.subrequestGUID), executorGUID: this.EXECUTOR_GUID, selectedMode: this.selectedMode}
                );
                this.SHOW_SUCCESS(data.message);
                return data;
            }catch(e){
                console.log(e);
                this.SHOW_ERROR(e);
            }finally {
                this.importCounts();
            }
        },

        onPaginate(data){
            this.exportResults.meta.current_page = data;
            if(this.ORGANIZATION_ID){
                this.loadExportResults();
            }
        },

        onFilter: _.throttle(function(){
            this.loadExportResults();
        }, 2000),

        async loadExportResults(){
            if(this.ORGANIZATION_ID === null){
                return;
            }
            this.exportResults.data.splice(0, this.exportResults.data.length);
            try{
                this.isFetchResults = true;
                let result = await organizationApi.exportDebtResultMessages(
                    this.ID_WORK_SPACE, 
                    this.ORGANIZATION_ID, 
                    {params: {page: this.exportResults.meta.current_page, ...this.filters}}
                );
                this.exportResults = result.data;
            }catch(e){
                console.log(e);
                this.SHOW_ERROR('Ошибка загруки данных');
            }finally{
                this.isFetchResults = false;
            }
        },
        onClickNextOnRadioAutoResponses(){
          if('free' === this.enableAutoResponsesRadioGroup){
            this.onChangeDebtImportAutomat();
          }
          if('subs' === this.enableAutoResponsesRadioGroup){
            this.$router.push({name: 'SubscriptionPage'});
          }
        },

        async onChangeDebtImportAutomat(){
          if(true === this.debtImportAutomatCheckBox){
            if(false === this.userSubscriptionHasSocialCurrentOrganization){
              if(false === this.dialogEnableAutoResponses){
                this.dialogEnableAutoResponses = true;
                this.$nextTick(() => {
                  this.debtImportAutomatCheckBox = false;
                })
                return Promise.resolve();
              }
            }
          }
          this.fetchDebtImportAutomat = true;
          try{
            await this.TOGGLE_DEBT_IMPORT_AUTOMAT();
          }catch (e) {
            console.log(e);
          }finally {
            this.fetchDebtImportAutomat = false;
            this.debtImportAutomatCheckBox = this.IS_ENABLE_DEBT_IMPORT_AUTOMAT;
            this.dialogEnableAutoResponses = false;
          }
        },
    },

    computed: {
        ...mapGetters( 'user', ['USER_ID', 'HAS_ROLE', 'IS_ADMIN']),
        ...mapGetters( 'organizationExecutor', ['EXECUTOR_GUID', 'IS_FETCHING', 'HAS_EXECUTOR', 'EXECUTOR', 'FULL_NAME']),
        ...mapGetters( 'workspace', ['ID_WORK_SPACE', 'ORGANIZATION_ID', 'ORGANIZATION_DEBT_RESULTS_STATUS']),
        ...mapGetters( 'organization', ['IS_ENABLE_DEBT_IMPORT_AUTOMAT', 'DEBT_IMPORT_AUTOMAT_LEFT_DAYS']),
        ...mapGetters( 'userSubscription', {userSubscriptionHasSocialCurrentOrganization: "hasSocialCurrentOrganization"}),
        debtImportAutomatSwitchLabel(){
            let label = 'Автоматическое отправление в ГИС ЖКХ';
            if(this.IS_ENABLE_DEBT_IMPORT_AUTOMAT){
                const cases = [2, 0, 1, 1, 1, 2];
                const titles = ['день', 'дня', 'дней'];
                let number = this.DEBT_IMPORT_AUTOMAT_LEFT_DAYS;
                let day = `${titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]}`;
                label = label + ` (осталось ${this.DEBT_IMPORT_AUTOMAT_LEFT_DAYS} ${day})`
            }
            return label;
        },
        tableData(){
            if( ! Array.isArray(this.exportResults.data) ){
                return [];
            }
            return this.exportResults.data.map((item) => {
                return {
                    ...item,
                    requestInfo_housingFundObject_address: item.requestInfo_housingFundObject_address + ' ' + item.requestInfo_housingFundObject_addressDetails,
                    requestInfo_responseDate: moment(item.requestInfo_responseDate).format('DD.MM.YYYY'),
                    // importResponseLast_sent_status_slug: item.importResponseLast ? item.importResponseLast.sent_status_slug : ''
                }
            })
        },
        userIsAdmin(){
            return this.HAS_ROLE('admin');
        },
        showActionDetails(){
            return this.userIsAdmin;
        },
        tableHeaders(){
            let headers = [
                { text: 'Номер запроса', value: 'requestInfo_requestNumber' },
                { text: 'Статус ответа', value: 'responseStatus' },
                { text: 'Крайний срок ответа на запрос', value: 'requestInfo_responseDate' },
                { text: 'Адресная строка', value: 'requestInfo_housingFundObject_address' },
                { text: 'Действия', value: 'actions', sortable: false },
            ];
            if(this.filters.status === 'archive'){
                headers.splice(4, 0, { text: 'Задолженность', value: 'has_debt' });
            }
            if(this.isResponseState){
                return [
                    // { text: 'Выбрано', value: 'selected' },
                    { text: 'Номер запроса', value: 'requestInfo_requestNumber' },
                    // { text: 'Статус отправки ответа', value: 'importResponseLast_sent_status_slug' },
                    { text: 'Статус ответа', value: 'responseStatus' },
                    { text: 'Крайний срок ответа на запрос', value: 'requestInfo_responseDate' },
                    { text: 'Адресная строка', value: 'requestInfo_housingFundObject_address' },
                    { text: 'Задолженность', value: 'has_debt' },
                    { text: '', value: 'data-table-expand' },
                ]
            }
            return headers;
        },
        selectedIds(){
            if(this.isResponseState === false){
                return [];
            }
            return _.differenceBy(this.tableData, this.excludeIds, 'subrequestGUID');
        },
        selectedWithDebtorsLength(){
            return this.excludeIds.filter(debtor => debtor.housePersonDebtors.length > 0).length;
        },

        importDebtorsLength(){
            return this.exportResults.count_debtors - this.selectedWithDebtorsLength;
        },

        selectedLength(){
            if( ! this.exportResults.meta ){
                return 0;
            }
            return this.exportResults.meta.total - this.excludeIds.length;
        },
        show_expand(){
            return this.filters.mode === 'response';
        },
        datatable_loading_text(){
            if(this.isFetchImport){
                return "Генерация ответов... Ожидайте";
            }
            return "Загрузка данных. Ожидайте";
        },
        isShowWarningGis(){
            let givenDate = new Date();
            let day = givenDate.getDay();
            return day === 6 || day === 0 ;
        }
    }
}
</script>